import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=3beea7f5&"
import script from "./SignUp.vue?vue&type=script&lang=js&"
export * from "./SignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3beea7f5')) {
      api.createRecord('3beea7f5', component.options)
    } else {
      api.reload('3beea7f5', component.options)
    }
    module.hot.accept("./SignUp.vue?vue&type=template&id=3beea7f5&", function () {
      api.rerender('3beea7f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/SignUp.vue"
export default component.exports